<template>
  <div class="tw-flex tw-items-center tw-flex-wrap tw--m-1">
    <template v-for="(category, index) in categories">
      <div class="tw-text-sm tw-font-light tw-text-infinity-secondary-text tw-m-1 base-filter-badges-label">{{ category.name }}:</div>
      <BaseChip class="tw-m-1 base-filter-badge tw-text-infinity-secondary-text tw-text-infinity-secondary-text tw-border-infinity-border" v-for="badge in category.badges" :key="`${category.name}_${badge.id}`" :label="badge.name" closable @close="onClose(category.id, badge.id)"/>
    </template>
  </div>
</template>
<script>
import BaseChip from "../base-chip";
export default {
  components: { BaseChip },
  props: {
    categories: {
      type: Array
    }
  },
  methods: {
    onClose(categoryId, badgeId) {
      this.$emit('remove', { categoryId, badgeId })
    }
  }
}
</script>
<style lang="scss" scoped>
.base-filter-badge {
  & + .base-filter-badges-label {
    @apply tw-pl-3;
  }
}
</style>
